<template>
    <div class="d-inline" v-if="etapa">
        <span class="text-success ml-1" v-if="mostrarIconeFinanceiro">
            <i
                class="fa fa-check-circle fa-lg"
                title="Processo Recebido/Quitado"
            ></i>
        </span>
        <app-status
            class="text-success ml-1"
            :status="statusLabel"
            v-if="mostrarStatus"
        ></app-status>
    </div>
</template>

<script>
import { StatusComprometimento } from './StatusComprometimento'

export default {
    props: {
        etapa: Object
    },

    data() {
        return {}
    },

    computed: {
        mostrarIconeFinanceiro() {
            return (
                this.etapa &&
                (this.etapa.statusIdFat == 'F' || this.etapa.statusIdFat == 'Q')
            )
        },

        mostrarStatus() {
            return (
                this.etapa.statusComprometimento !==
                StatusComprometimento.COMPROMETIDO
            )
        },

        statusLabel() {
            if (this.etapa.responsavelComprometimento == 'SEF') {
                switch (this.etapa.statusComprometimento) {
                    case StatusComprometimento.NAO_COMPROMETIDO:
                        return 'NÃO COMPROMETIDO'
                    case StatusComprometimento.ERRO:
                        return 'ERRO'
                    case StatusComprometimento.COMPROMETIMENTO_EXCLUIDO:
                        return 'EXCLUÍDO'
                    case StatusComprometimento.ATUALIZAR_COMPROMETIMENTO:
                        return 'EM ATUALIZAÇÃO'
                    default:
                        return ''
                }
            } else {
                return 'SGTEC'
            }
        }
    }
}
</script>
